import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import Label from '../Label';
/**
 * @private
 * 表单标签容器
 */
var FormLabelContainer = styled(Label).attrs(function (_a) {
    var htmlFor = _a.htmlFor, name = _a.name;
    return ({
        htmlFor: htmlFor || name,
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  box-sizing: border-box;\n  padding: 4px 8px;\n  padding-left: 0;\n  text-align: ", ";\n  ", "\n  ", "\n"], ["\n  width: ", ";\n  box-sizing: border-box;\n  padding: 4px 8px;\n  padding-left: 0;\n  text-align: ", ";\n  ", "\n  ",
    "\n"])), function (props) { return (props.vertical ? '100%' : props.width || '120px'); }, function (props) { return (props.vertical ? 'left' : props.align); }, function (props) { return !props.vertical && 'min-height: 36px;'; }, function (props) {
    return props.colon &&
        "\n    &::after {\n      content: \":\";\n      margin: 0 8px 0 2px;\n    }\n  ";
});
export default FormLabelContainer;
var templateObject_1;
//# sourceMappingURL=FormLabelContainer.js.map